module.exports = __webpack_public_path__ + "static/img/mobile-scroll-tip-arrow.dfd775c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile-scroll-tip-arrow.png
// module id = 451
// module chunks = 1